import { render, staticRenderFns } from "./ViewScopingSearchStrings.vue?vue&type=template&id=2dd4f280&scoped=true"
import script from "./ViewScopingSearchStrings.vue?vue&type=script&lang=js"
export * from "./ViewScopingSearchStrings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd4f280",
  null
  
)

export default component.exports